(() => {
    'use strict';

    const configuration = document.getElementById('sb-shop-analytics-config');
    if (!configuration) return;
    let context;
    try {
        context = JSON.parse(configuration.textContent);
    } catch (_) {
        return;
    }
    if (!context || typeof context !== 'object') return;

    const pageTypes = ['index', 'product', 'collection', 'list-collections', 'search', 'cart', 'page', 'blog', 'article'];
    const pageType = pageTypes.includes(context.page_type) ? context.page_type : 'other';
    const country = /^[A-Z]{2}$/.test(context.market_country) ? context.market_country : 'unknown';
    const currency = /^[A-Z]{3}$/.test(context.market_currency) ? context.market_currency : 'unknown';
    const websitePages = ['how-it-works', 'schedule-a-pickup', 'contact', 'articles', 'privacy-policy', 'terms-of-use'];
    let privacyRequested = false;

    function requestPrivacyAPI() {
        if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function'
            || privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
        privacyRequested = true;
        try {
            window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], () => {
            });
        } catch (_) {
            // Missing privacy information disables these optional events.
        }
    }

    function pageContext() {
        if (location.protocol !== 'https:' || location.hostname !== 'shop.sustainablebooks.com') return null;
        const path = location.pathname;
        const publicPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages|blogs)\/[a-z0-9_-]+(?:\/[a-z0-9_-]+)?|search|cart|collections)?\/?$/.test(path);
        let referrer = '';
        try {
            const source = new URL(document.referrer);
            if (['http:', 'https:'].includes(source.protocol)) referrer = source.origin;
        } catch (_) {
            // An unavailable referrer stays empty.
        }
        return {
            page_location: location.origin + (publicPath ? path : '/'),
            page_referrer: referrer,
            page_title: 'Sustainable Books shop',
        };
    }

    function publish(name, details) {
        requestPrivacyAPI();
        try {
            if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true
                || typeof window.gtag !== 'function') return;
            const page = pageContext();
            if (!page) return;
            // Reuse the native app's configured tag. Never load or configure another tag.
            window.gtag('event', name, {
                send_to: 'G-DEEE0QTF3V',
                ...page,
                page_type: pageType,
                market_country: country,
                market_currency: currency,
                ...details,
            });
        } catch (_) {
            // Measurement must never interrupt navigation or localization.
        }
    }

    function placement(element) {
        if (element.closest('header')) return 'header';
        if (element.closest('footer')) return 'footer';
        return 'body';
    }

    document.addEventListener('click', event => {
        const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
        if (!link) return;
        let destination;
        try {
            destination = new URL(link.href);
        } catch (_) {
            return;
        }
        const linkPlacement = placement(link);
        if (['mailto:', 'tel:'].includes(destination.protocol)) {
            publish('contact_click', {
                contact_method: destination.protocol === 'tel:' ? 'phone' : 'email',
                link_placement: linkPlacement,
            });
        }
        if (destination.protocol !== 'https:' || destination.username || destination.password
            || !['sustainablebooks.com', 'sustainablebooks.ca'].includes(destination.hostname)) return;
        const parts = destination.pathname.split('/').filter(Boolean);
        if (!['ca', 'us'].includes(parts[0])) return;
        let destinationPage = parts.length === 1 ? 'home' : 'other';
        if (websitePages.includes(parts[1])) destinationPage = parts[1];
        if (parts[1] === 'services' && ['thrift-stores', 'libraries', 'bookstores'].includes(parts[2])) {
            destinationPage = `services-${parts[2]}`;
        }
        publish('main_website_visit', {
            link_placement: linkPlacement,
            destination_region: parts[0],
            destination_page: destinationPage,
        });
    });

    document.addEventListener('submit', event => {
        if (!(event.target instanceof HTMLFormElement) || !event.target.matches('form.sb-country-form')) return;
        const selected = event.target.elements.namedItem('country_code')?.value;
        if (typeof selected !== 'string' || !/^[A-Z]{2}$/.test(selected)
            || !Object.hasOwn(context.markets || {}, selected) || selected === country) return;
        const selectedCurrency = context.markets[selected];
        if (typeof selectedCurrency !== 'string' || !/^[A-Z]{3}$/.test(selectedCurrency)) return;
        publish('market_selected', {
            link_placement: placement(event.target),
            selected_market_country: selected,
            selected_market_currency: selectedCurrency,
        });
    });

    requestPrivacyAPI();
    window.addEventListener('load', requestPrivacyAPI, {once: true});
    // Always read the current permission at the action, including after withdrawal.
    document.addEventListener('visitorConsentCollected', requestPrivacyAPI);
})();
